<template>
    <div style="width: 1000px;">
        <el-form :inline="true" :model="jobOrderForm"  :rules="jobRules"  ref="jobOrderForm" class="demo-form-inline" size="small">
            <el-row :gutter="0">
                <el-col :span="5">
                    <el-form-item label-width="100px" label="工作單號：" prop="jobNo">
                      {{jobOrderForm.jobNo}}
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item label-width="100px" label="版本：" prop="ver">
                       {{jobOrderForm.ver}}
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item label-width="100px" label="製單人：" prop="createBy">
                        {{jobOrderForm.createBy}}
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label-width="100px" label="日期：" prop="createTime">
                      {{getIssueDate(jobOrderForm.createTime)}}
                    </el-form-item>
                </el-col>
            </el-row>
           <el-row type="flex">
                     <el-col :span="5.3">
           			    <el-form-item label-width="100px" label="日期：" prop="startDate">
           			                        <el-date-picker
           			                                @change="getTimes"
           			                                v-model="jobOrderForm.startDate"
           			                                type="date"
           			                                placeholder=""
           			                                style="width:140px"
           			                        >
           			                        </el-date-picker>
           			                     </el-form-item>
           			</el-col>
           			
                     <el-col :span="0.5">
           			<div style="margin-top: 5px;margin-right: 7px;">~</div>
           			</el-col>
                     <el-col :span="3">
           			  <el-form-item  prop="endDate">
           			                        <el-date-picker
           			                                v-model="jobOrderForm.endDate"
           			                                type="date"
           			                                placeholder=""
           			                                style="width:140px"
           			                        >
           			                        </el-date-picker>
           			                    </el-form-item>
           			
           			</el-col>
           			 <el-col :span="6">
           				 
           				 <el-form-item label-width="100px" label="時間：" prop="jobTime">
           					 <el-input placeholder=""   v-model="jobOrderForm.jobTime" style="width:140px">
           				                    </el-input>
           				                    </el-form-item>
           				 
           				 </el-col>
           				 
           				 <el-col :span="7">
           				 					 
           				 				 <el-form-item label-width="100px" label="服務類別：" prop="service">
           				 				                        <el-select v-model="jobOrderForm.service" placeholder="" style="width:160px">
           				 				                            <el-option
           				 				                                    v-for="item in serviceOption"
           				 				                                    :key="item.value"
           				 				                                    :label="item.label"
           				 				                                    :value="item.value">
           				 				                            </el-option>
           				 				                        </el-select>
           				 				                    </el-form-item>
           				 					 
           				 					 </el-col>
                   </el-row>
           		
           		<el-row  type="flex">
           					   <el-col :span="6">
           					                          <el-form-item label-width="100px" label="客戶：" prop="custNo">
           					                              <el-select v-model="jobOrderForm.custNo" default-first-option valueKey="id" placeholder="" filterable  remote  :remote-method="itemRemoteMethod" @change="custChange" style="width:140px">
           					                                  <el-option
           					                                          v-for="item in custOptions"
           					                                          :key="item.id"
           					                                          :label="item.code"
           					                                          :value="item">
           					                                      <span style="float: left">{{ item.code }}</span>&nbsp;
           					                                      <span style="float: right; color: #8492a6; font-size: 13px">{{ item.name }}</span>
           					                                  </el-option>
           					                              </el-select>
           					                          </el-form-item>
           					                  </el-col>
           									 <el-col :span="8">
           									      <el-form-item label-width="100px" label="姓名：" >
           									         {{jobOrderForm.custName}}
           									      </el-form-item>
           									  </el-col>
           									    <el-col :span="6">
           									                      <el-form-item label-width="100px" label="大小容量：" prop="volume">
           									                          <el-input placeholder=""   v-model="jobOrderForm.volume" style="width:140px">
           									                          </el-input>
           									                      </el-form-item>
           									                  </el-col>
           				   </el-row>
           				   <el-row  type="flex">
           				   			   <el-col >
           				   			                     <el-form-item label-width="100px" label="起點：" prop="origin">
           				   			                         <el-input placeholder=""   v-model="jobOrderForm.origin" style="width:800px">
           				   			                         </el-input>
           				   			                     </el-form-item>
           				   			                 </el-col>
           				   							 
           				    </el-row>
           		
           
                  
           	   <el-row  type="flex">
           	   			   <el-col >
           	   			                  <el-form-item label-width="100px" label="目的地：" prop="dest">
           	   			                                         <el-input placeholder=""   v-model="jobOrderForm.dest" style="width:800px">
           	   			                                         </el-input>
           	   			                                     </el-form-item>
           	   			                 </el-col>
           	   							 
           	    </el-row>
           	   <el-row type="flex">
           	     <el-col :span="5.3">
           	   				  <el-form-item label-width="100px" label="聯絡人：" prop="contactP">
           	   				                         <el-input placeholder=""   v-model="jobOrderForm.contactP" style="width:170px">
           	   				                         </el-input>
           	   				                     </el-form-item>
           	   				</el-col>
           	   				
           	     
           	     <el-col :span="5.3">
           	   				  <el-form-item label-width="100px" label="電話號碼：" prop="contactT">
           	   				                         <el-input placeholder=""   v-model="jobOrderForm.contactT" style="width:170px">
           	   				                         </el-input>
           	   				                     </el-form-item>
           	   				
           	   				</el-col>
           	   </el-row>
			<el-row type="flex">
				<el-col :span="5.3">
					<el-form-item label-width="100px" label="主管：" prop="supervisor">
						<el-input placeholder=""   v-model="jobOrderForm.supervisor" style="width:170px">
						</el-input>
					</el-form-item>
				</el-col>


				<el-col :span="5.3">
					<el-form-item label-width="100px" label="打印代碼：" prop="printCode">
						<el-input placeholder=""   v-model="jobOrderForm.printCode" style="width:170px">
						</el-input>
					</el-form-item>

				</el-col>
				<el-col :span="5.3">
					<el-form-item label-width="100px" label="是否收錢：" prop="cashOrder">
						<el-input placeholder=""   v-model="jobOrderForm.cashOrder" style="width:240px">
						</el-input>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row type="flex">
				<el-col :span="24">
					<el-form-item label-width="100px" label="備註：" prop="remark">
					<!--	<el-select v-model="remark" placeholder="" style="width:800px">
							<el-option
									v-for="item in remarkOption"
									:key="item.value"
									:label="item.label"
									:value="item.value">
							</el-option>
						</el-select>-->
						<el-select label-width="100px" v-model="remark" placeholder="備註" prop="remark" style="width:800px">
							<el-option
									v-for="item in remarkList"
									:key="item.id"
									:label="item.content"
									:value="item.content">
							</el-option>
						</el-select>
					</el-form-item>
					<el-button size="small" type="primary" style="background-color:#b68e38;border-color:#b68e38;"  @click="addRemark"><i class="fa fa-plus" /> 添加</el-button>
				</el-col>
			</el-row>
           	   <el-row  type="flex">
           	   			   <el-col >
           	   			                 <el-form-item label-width="100px" label="工作內容：" prop="jobDetail">
           	   			                                        <el-input
																		id="textareaAddId"
           	   			                                                type="textarea"
           	   			                                                :autosize="{ minRows: 8, maxRows:18}"
           	   			                                                placeholder=""
           	   			                                                v-model="jobOrderForm.jobDetail" style="width: 800px;">
           	   			                                        </el-input>
           	   			                                     </el-form-item>
           	   			                 </el-col>
           	   							 
           	    </el-row>
           	   
           	   <el-row  type="flex">
           	   			   <el-col :span="6">
           	   			                         <el-form-item label-width="100px" label="預計箱：" prop="estQty1">
           	   			                                                 <el-input placeholder=""  v-model="jobOrderForm.estQty1" style="width:140px">
           	   			                                                 </el-input>
           	   			                                             </el-form-item>
           	   			                  </el-col>
           	   							    <el-col :span="6">
           	   							                   <el-form-item label-width="100px" label="真實箱：" prop="realQty1">
           	   							                                          <el-input placeholder=""  v-model="jobOrderForm.realQty1" style="width:140px">
           	   							                                          </el-input>
           	   							                                      </el-form-item>
           	   							                  </el-col>
           	    </el-row>
           	   
           	   <el-row  type="flex">
           	   			   <el-col :span="6">
           	   			                        <el-form-item label-width="100px" label="預計板：" prop="estQty2">
           	   			                                               <el-input placeholder=""  v-model="jobOrderForm.estQty2" style="width:140px">
           	   			                                               </el-input>
           	   			                                           </el-form-item>
           	   			                  </el-col>
           	   							    <el-col :span="6">
           	   							                  <el-form-item label-width="100px" label="真實板：" prop="realQty2">
           	   							                                         <el-input placeholder=""  v-model="jobOrderForm.realQty2" style="width:140px">
           	   							                                         </el-input>
           	   							                                     </el-form-item>
           	   							                  </el-col>
           	    </el-row>
            <el-row :gutter="0">
				<el-button size="small" type="primary" style="float: left;margin-bottom: 5px;margin-left: 15px;" @click="jobSave">保存</el-button>
				<el-button size="small" type="primary" style="float: left;margin-bottom: 5px;margin-left: 15px;" @click="goBack">關閉</el-button>
				<el-button size="small" type="primary" style="float: right;margin-bottom: 5px;margin-left: 15px;background-color:#b68e38;border-color:#b68e38;margin-right: 99px;"  @click="jobSaveItemLoad"><i class="fa fa-plus" /> 複製新增工作單</el-button>
            </el-row>
        </el-form>

		<!-- 客戶組名編輯页面 -->
		<el-dialog :title="dialogJobName" :visible.sync="dialogDiscJobVisible" width="360px" :close-on-click-modal=false>
			<el-form  :model="jobForm"  :rules="jobRules" ref="jobForm" label-width="100px">
				<el-row :gutter="0">
					<el-col :span="24">
						<el-form-item label-width="100px" label="服務類別：" prop="service">
							<el-select v-model="jobForm.service" placeholder=""  style="width:180px">
								<el-option
										v-for="item in serviceOption"
										:key="item.value"
										:label="item.label"
										:value="item.value">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>

			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogDiscJobVisible = false">{{$t('m.b_cancel')}}</el-button>
				<el-button type="primary"  @click="jobSaveItem" :loading="Addloading">{{$t('m.b_save')}}</el-button>
			</div>
		</el-dialog>
    </div>
</template>

<script>
    import axios from 'axios'
    import {getJobRecord,getCustAllCustMgtList,updateJobOrder,insertJobOrder,getJobNo,getAllRemarkList} from '../api/api'
    export default {
        data() {
            var checkStart = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('請選擇開始日期'));
                }else {
                    if(this.jobOrderForm.endDate!="") {
                        var oldStartDate = new Date(value).getTime() / 1000;
                        var oldEndDate = new Date(this.jobOrderForm.endDate).getTime() / 1000;
                        if (oldStartDate>oldEndDate) {
                            callback(new Error('開始日期不能大於結束日期'));
                        }
                    }
                }
                callback();
            };
            var checkEnd = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('請選擇結束日期'));
                }else {
                    if(this.jobOrderForm.startDate!="") {
                        var oldStartDate = new Date(this.jobOrderForm.startDate).getTime() / 1000;
                        var oldEndDate = new Date(value).getTime() / 1000;
                        if (oldEndDate < oldStartDate) {
                            callback(new Error('結束日期不能小於開始日期'));
                        }
                    }
                }
                callback();
            };
            return {
                pickerOptions0: {
                    disabledDate(time) {
                        return time.getTime() < Date.now() - 8.64e7;
                    }
                },
                jobOrderForm:{
                    id:'',
                    jobNo:'',
                    startDate:'',
                    endDate:'',
                    jobTime:'',
                    volume:'',
                    custId:'',
                    custNo:'',
                    service:'OB',
                    origin:'',
                    dest:'',
                    contactP:'',
                    contactT:'',
                    estQty1:'',
                    estQty2:'',
                    realQty1:'',
                    realQty2:'',
                    cashOrder:'',
                    jobDetail:'',
                    status:0,
                    custName:'',
                    ver:1,
                    createBy:'',
                    createTime:'',
                    supervisor:'',
                    printCode:'',
					jobId:''
                },
				remark:'',
                custOptions:[],
                remarkOption:[
                    {
                        value: '＊ 易 碎 或 不 可 壓 的 紙 箱 , 請 小 心 包 裝 及 搬 運 ＊',
                        label: '＊ 易 碎 或 不 可 壓 的 紙 箱 , 請 小 心 包 裝 及 搬 運 ＊'
                    },{
                        value: '＊ 搬 運 時 請 留 意 單 位 內 地 板 及 牆 身 , 用 物 料 保 護 以 免 刮 花 ＊',
                        label: '＊ 搬 運 時 請 留 意 單 位 內 地 板 及 牆 身 , 用 物 料 保 護 以 免 刮 花 ＊',
                    },{
                        value: '※易碎物品或不可壓的物品要用“易碎”貼紙標識, 並小心包裝及搬運※',
                        label: '※易碎物品或不可壓的物品要用“易碎”貼紙標識, 並小心包裝及搬運※',
                    }
                ],
                serviceOption:[
                    {
                        value: 'OB',
                        label: 'OB 出口(Outbound)'
                    },{
                        value: 'RL',
                        label: 'RL 搬屋/搬運',
                    },{
                        value: 'ORL',
                        label: 'ORL 搬寫字樓',
                    },{
                        value: 'STG',
                        label: 'STG 存倉',
                    },{
                        value: 'IB',
                        label: 'IB 入口',
                    }, {
                        value: 'SELL',
                        label: 'SELL 賣盒',
                    }, {
                        value: 'MAIL',
                        label: 'MAIL 寄件',
                    }, {
                        value: 'OBOX',
                        label: ' 送盒(OBOX)',
                    },
                    {
                        value: 'IBOX',
                        label: '收盒(IBOX)',
                    },
                    {
                        value: 'OTHER',
                        label: '其它(OTHER)',
                    },
                ],
                jobRules:{
                    startDate:[
                        {required: true, message: '開始日期不能為空', trigger: 'change' },
                        {validator: checkStart,trigger: 'change' }
                    ],
                    endDate:[
                        {required: true, message: '結束日期不能為空', trigger: 'change' },
                        {validator: checkEnd,trigger: 'change' }
                    ],
                    custNo:[
                        {required: true, message: '客戶不能為空', trigger: 'change' },
                    ],
                    service:[
                        {required: true, message: '服務類別不能為空', trigger: 'change' },
                    ],
                    origin:[
                        {required: false, message: '起點不能為空', trigger: 'change' },
                        { min: 1, max: 2000, message: '長度在 1 到 2000 個字符', trigger: 'change' },
                    ],
                    dest:[
                        { min: 1, max: 2000, message: '長度在 1 到 2000 個字符', trigger: 'change' },
                    ],
                    contactP:[
                        { min: 1, max: 20, message: '長度在1到20個字符', trigger: 'change' }
                    ],
                    contactT:[
                        { min: 1, max: 30, message: '長度在1到30個字符', trigger: 'change' }
                    ],
                    estQty1:[
                        {required: true, message: '預計箱數量不能為空', trigger: 'change' },
                        {required: true, validator: function (rule, value, callback) {
                            var reg = /^[0-9]+$/;
                            if (value != "" && value != null) {
                                if (!reg.test(value)) {
                                    callback(new Error('請輸入正數！'));
                                }
                            }
                            callback();
                        }, trigger: 'blur'
                        }
                    ],
                    realQty1:[
                        {required: false, validator: function (rule, value, callback) {
                            var reg = /^[0-9]+$/;
                            if (value != "" && value != null) {
                                if (!reg.test(value)) {
                                    callback(new Error('請輸入正數！'));
                                }
                            }
                            callback();
                        }, trigger: 'blur'
                        }
                    ],
                    estQty2:[
                        {required: true, message: '預計板數量不能為空', trigger: 'change' },
                        {required: false, validator: function (rule, value, callback) {
                            var reg = /^[0-9]+$/;
                            if (value != "" && value != null) {
                                if (!reg.test(value)) {
                                    callback(new Error('請輸入正數！'));
                                }
                            }
                            callback();
                        }, trigger: 'blur'
                        }
                    ],
                    realQty2:[
                        {required: false, validator: function (rule, value, callback) {
                            var reg = /^[0-9]+$/;
                            if (value != "" && value != null) {
                                if (!reg.test(value)) {
                                    callback(new Error('請輸入正數！'));
                                }
                            }
                            callback();
                        }, trigger: 'blur'
                        }
                    ],
                    jobDetail:[
                        {required: true, message: '工作內容不能為空', trigger: 'change' },
                        { min: 1, max: 2000, message: '長度在1到2000個字符', trigger: 'change' }
                    ],
                },
                acctId:'',
                jobForm:{
                    service:''
				},
                jobRules:{
                    service:[
                        {required: true, message: '服務類別不能為空', trigger: 'change' },
                    ],
				},
                dialogJobName:'',
                dialogDiscJobVisible:false,
                Addloading:false,
                remarkList:[]
            }
        },
        methods: {
            getRemarkList(){/*查詢常用列表*/
                return getAllRemarkList(2).then(data =>{
                    let {data:res={}}=data;
                    if(res.errcode===200){
                        this.remarkList = res.data;
                    }
                });
            },
            addRemark(){
                var str=document.getElementById('textareaAddId').value;
                /*if(str.indexOf('＊')!=-1 || str.indexOf('※')!=-1){*/
                    document.getElementById('textareaAddId').value = document.getElementById('textareaAddId').value + "\n" +this.remark;
                /*}else{
                    document.getElementById('textareaAddId').value = document.getElementById('textareaAddId').value + "\n\n\n\n" +this.remark;
                }
                this.remark='＊ 易 碎 或 不 可 壓 的 紙 箱 , 請 小 心 包 裝 及 搬 運 ＊';*/
            },
            getIssueDate(value){
                if(value!=''|| value!=0) {
                    var d = new Date(value);
                    var m = d.getMonth() + 1;
                    return d.getFullYear() + '-' + m + '-' + d.getDate() +" "+d.getHours()+":"+d.getMinutes();
                }
            },
            custChange(ev){
                if(ev!="") {
                    this.jobOrderForm.custNo=ev.code;
                    this.jobOrderForm.custId = ev.id;
                    this.jobOrderForm.origin = ev.address;
                    this.jobOrderForm.custName=ev.name;
                    this.jobOrderForm.contactP=ev.sales;
                    this.jobOrderForm.contactT=ev.phone;
                }else{
                    this.resetForm("jobOrderForm");
                    this.jobOrderForm.custNo="";
                    this.jobOrderForm.custId = "";
                    this.jobOrderForm.origin = "";
                    this.jobOrderForm.custName="";
                    this.jobOrderForm.contactP="";
                    this.jobOrderForm.contactT="";
                }
               /* if(ev!="") {
                    this.jobOrderForm.custNo=ev.code;
                    this.jobOrderForm.custId = ev.id;
                    this.jobOrderForm.origin = ev.address;
                }else{
                    this.resetForm("jobOrderForm");
                    this.jobOrderForm.custNo="";
                    this.jobOrderForm.custId = "";
                    this.jobOrderForm.origin = "";
                }*/
            },
            getTimes(ev){
                this.jobOrderForm.endDate=ev;
            },
            itemRemoteMethod(query){
                if (query!=""){
                    var params={custNo:query,groupId:null};
                    getCustAllCustMgtList(params).then(data=>{
                        let {data:res={}}=data;
                        this.custOptions=res.data;
                    });
                }
            },
            resetForm(formName){
                if (this.$refs[formName] !== undefined) {
                    this.$refs[formName].resetFields();
                }
            },
            validateChange(ev){
                if(ev!=null && ev!=''){
                    var re=/^[0-9]\d*\.{0,1}\d{0,1}$/;
                    if(!re.test(ev)){
                        this.$message.error("請輸入正確的格式，數字只有1位小數");
                        return false;
                    }
                }
            },

            jobSave(){
                this.$refs.jobOrderForm.validate((valid) => {
                    if (valid) {
                        var params1={jobNo:this.jobOrderForm.jobNo.trim(),service:this.jobOrderForm.service,id:this.jobOrderForm.id};
                        getJobNo(params1).then(data => {
                            let {data:res={}}=data;
                            if (res.data !="") {
                                return this.$message.error(this.jobOrderForm.jobNo+"工作單號服務類別 "+this.jobForm.service+" 已存在，請重新選擇！");
                            }else {
                                if (this.jobOrderForm.startDate == '') {
                                    this.jobOrderForm.startDate = 0
                                }
                                if (this.jobOrderForm.endDate == '') {
                                    this.jobOrderForm.endDate = 0
                                }
                                var params = Object.assign({}, this.jobOrderForm);
                                params.createTime = Math.round(new Date(params.createTime).getTime() / 1000);
                                params.startDate = Math.round(new Date(params.startDate).getTime() / 1000);
                                params.endDate = Math.round(new Date(params.endDate).getTime() / 1000);
                                params.status = 0;
                                params.jobDetail=document.getElementById('textareaAddId').value;
                                //params.service=this.jobOrderForm.service.join(",");
                                updateJobOrder(params).then(data => {
                                    let {errcode, errmsg} = data.data;
                                    if (errcode == 200) {
                                        this.$message.success("修改成功");
                                        this.resetForm("jobOrderForm");
                                        this.acctId = '';
                                        this.$router.push({
                                            name: '工作單',
                                            params: {str: new Date().getTime()}
                                        })
                                        this.$store.commit("closeTab", 'jobEdit');
                                    } else {
                                        this.$message.error("修改失败！");
                                    }
                                },);
                            }}
                            )
                    }
                });
            },

            jobSaveItemLoad(){
                this.jobForm.service="";
				this.dialogJobName='複製新增工作單';
				this.dialogDiscJobVisible=true;
			},
            jobSaveItem(){
                this.$refs.jobForm.validate((valid) => {
                    if (valid) {
                        var params1={jobNo:this.jobOrderForm.jobNo.trim(),service:this.jobForm.service,id:''};
                        getJobNo(params1).then(data => {
                            let {data:res={}}=data;
                            if (res.data !="") {
                                return this.$message.error(this.jobOrderForm.jobNo+"工作單號服務類別 "+this.jobForm.service+" 已存在，請重新選擇！");
                            }else {
                                if (this.jobOrderForm.startDate == '') {
                                    this.jobOrderForm.startDate = 0
                                }
                                if (this.jobOrderForm.endDate == '') {
                                    this.jobOrderForm.endDate = 0
                                }
                                var params = Object.assign({}, this.jobOrderForm);
                                params.createTime = Math.round(new Date(params.createTime).getTime() / 1000);
                                params.startDate = Math.round(new Date(params.startDate).getTime() / 1000);
                                params.endDate = Math.round(new Date(params.endDate).getTime() / 1000);
                                params.jobNo = this.jobOrderForm.jobNo.trim();
                                params.service=this.jobForm.service;
                                params.status = 0;
                                insertJobOrder(params).then(data => {
                                    let {errcode, errmsg} = data.data;
                                    if (errcode == 200) {
                                        this.$message.success("複製新增成功!");
                                        this.dialogDiscJobVisible=false;
                                        this.resetForm("jobOrderForm");
                                        this.resetForm("jobForm");
                                        this.$router.push({
                                            name: '工作單',
                                            params: {str: new Date().getTime()}
                                        })
                                        this.$store.commit("closeTab", 'jobEdit');
                                    } else {
                                        this.dialogDiscJobVisible=false;
                                        this.$message.error("複製新增失败！");
                                    }
                                });
                            }},);
                    }
                });
            },
            goBack(){
                this.acctId == '';
                this.$router.push({
                    name:'工作單',
                    params:{str:new Date().getTime()}
                })
                this.$store.commit("closeTab","jobEdit");
            },
            getJobParams(){
              /*  if (this.acctId == '') {
                    this.acctId = this.$route.params.jobId;
                    if (this.acctId != '' || this.acctId != undefined) {
                        this.queryOneAcctRec(this.acctId);
                    }
                }
                if (this.acctId != this.$route.params.jobId && this.$route.params.jobId != undefined) {*/
                    this.acctId = this.$route.params.jobId;
                    this.queryOneAcctRec(this.acctId);
                //}
            },
            queryOneAcctRec(acctId){
                if(acctId!=undefined){
                    return getJobRecord(acctId).then(data => {
                        let item = data.data;
                        if (item.data[0] != null) {
                            Object.assign(this.jobOrderForm, item.data[0]);

                             var params={custNo:item.data[0].custNo,groupId:null};
                            getCustAllCustMgtList(params).then(data=>{
                                let {data:res={}}=data;
                                this.custOptions=res.data;
                            });

                            //let typeS=item.data[0].service.split(",")
							this.jobOrderForm.service=item.data[0].service;
                            this.jobOrderForm.estQty1=parseInt(item.data[0].estQty1);
                            this.jobOrderForm.estQty2=parseInt(item.data[0].estQty2);

                            if(item.data[0].realQty1!=null && item.data[0].realQty1!=0){
                                this.jobOrderForm.realQty1=parseInt(item.data[0].realQty1);
							}else{
                                this.jobOrderForm.realQty1="";
							}
                            if(item.data[0].realQty2!=null && item.data[0].realQty2!=0) {
                                this.jobOrderForm.realQty2 = parseInt(item.data[0].realQty2);
                            }else{
                                this.jobOrderForm.realQty2="";
							}
                            if (item.data[0].startDate == 0) {
                                this.jobOrderForm.startDate = "";
                            } else {
                                this.jobOrderForm.startDate = new Date(item.data[0].startDate * 1000);
                            }
                            if (item.data[0].createTime == 0) {
                                this.jobOrderForm.createTime = "";
                            } else {
                                this.jobOrderForm.createTime = new Date(item.data[0].createTime * 1000);
                            }
                            if (item.data[0].endDate == 0) {
                                this.jobOrderForm.endDate = "";
                            } else {
                                this.jobOrderForm.endDate = new Date(item.data[0].endDate * 1000);
                            }
                        }
                    });
                }
            }
        },
        mounted() {
        },
        activated(){
            this.getJobParams();
            this.getRemarkList();
        },
        computed: {
        }
    }

</script>

<style lang="scss">
    .menu {
        .right {
            float: right;
        }
    }
    .el-tag + .el-tag {
        margin-left: 5px;
    }

    .dataListTable .cell {
        white-space: nowrap;
    }
</style>



// WEBPACK FOOTER //
// src/views/UpdateJobOrder.vue